import {
    LEE_ACCEPT_CALLBACK_URLS,
    LEE_CONFIRM_COMPONENT,
    LEE_DEFAULT_CALLBACK_URL,
    LEE_EMAIL_DOMAINS,
    LEE_LINKAGE_ID,
    LEE_LINKAGE_NAME,
    LEE_LOGIN_CUSTOM_COMPONENT,
    LEE_PATH,
    LEE_PROFILE_COMPONENT,
    LEE_SERVICE_TERM_URL,
    LEE_SITE_UNIQ_API_PATH
} from "@/commons/linkage/sites/lee";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory } from "vue-router";

// LEE画面用ルート定義
const routes = createLinkageRoute(
    LEE_LINKAGE_ID,
    LEE_LINKAGE_NAME,
    LEE_PATH,
    LEE_SITE_UNIQ_API_PATH,
    LEE_DEFAULT_CALLBACK_URL,
    LEE_ACCEPT_CALLBACK_URLS,
    LEE_SERVICE_TERM_URL,
    LEE_EMAIL_DOMAINS,
    LEE_PROFILE_COMPONENT,
    LEE_CONFIRM_COMPONENT,
    {
        loginCustomComponent: LEE_LOGIN_CUSTOM_COMPONENT,
    }
);

// LEE画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// LEE画面用ルータ
export const leeRouter = router;
